import safeLocalStorage from 'safe-localstorage';
import store from 'src/store';
import { NOTIFICATION_SUPPORT } from 'src/services/notification';

export default class NotificationsHandler {
  static async check() {
    const state = await this.getNotificationState();

    if (!state) {
      store().dispatch('notifications/setNotificationSupport', NOTIFICATION_SUPPORT.NONE);
      return false;
    }

    if (state === NOTIFICATION_SUPPORT.GRANTED) {
      store().dispatch('notifications/setNotificationSupport', NOTIFICATION_SUPPORT.GRANTED);
      return false;
    }

    if (state === NOTIFICATION_SUPPORT.DENIED) {
      store().dispatch('notifications/setNotificationSupport', NOTIFICATION_SUPPORT.DENIED);
      return false;
    }

    if (safeLocalStorage.get('notifications/deferred', 'false') === 'true') {
      store().dispatch('notifications/setNotificationSupport', NOTIFICATION_SUPPORT.DEFERRED);
      return false;
    }

    return true;
  }

  static getNotificationState() {
    throw new Error('getNotificationState() method is not implemented!');
  }

  static init() {
    throw new Error('init() method is not implemented!');
  }

  static openSettings() {
    throw new Error('openSettings() method is not implemented!');
  }

  static request() {
    throw new Error('request() method is not implemented!');
  }
}
